export default "__VITE_PUBLIC_ASSET__590e6722__"